import { JwtService } from './jwt.service';

import { of as observableOf, Observable, zip, forkJoin } from 'rxjs';

import { map, catchError, tap, mergeMap, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { LoadSpinnerService } from './load-spinner.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
import { ApplicationService } from './application.service';

@Injectable({
  providedIn: 'root'
})
export class NexalesService {

  private nexales_api_key: string;
  private nexales_api_key_user: string;
  private nexales_api_url: string;

  constructor(
    private http: HttpClient, 
    private jwtService: JwtService, 
    private loader: LoadSpinnerService,
    private applicationService: ApplicationService
  ) {}

  public fetchPresentations(searchText: string = ''): Observable<any> {
    return this.ensureApiKeys().pipe(
      switchMap(() => this.fetchPresentations_internal(searchText))
    );
  }

  private ensureApiKeys(): Observable<void> {
    return this.applicationService.getEnvironmentVariables().pipe(
      map((env) => {
        this.nexales_api_key = env.nexales_api_key;
        this.nexales_api_key_user = env.nexales_api_key_user;
        this.nexales_api_url = env.nexales_api_url;
        if (!this.nexales_api_key || !this.nexales_api_key_user || !this.nexales_api_url) {
          throw new Error('Nexales API keys are not configured properly.');
        }
      })
    );
  }

  private fetchPresentations_internal(searchText: string = ''): Observable<any> {
    this.loader.showSpinner();

    const headers = new HttpHeaders({
      ApiKey: this.nexales_api_key,
      ApiKeyUser: this.nexales_api_key_user,
      ignore: 'true',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
      'Access-Control-Allow-Headers':
        'Origin, Content-Type, Access-Control-Allow-Headers, Authorization, ApiKey, X-Requested-With'
    });

    return this.http
      .get(
        `${this.nexales_api_url}/presentations?filters[0].type=1200&filters[0].value=${encodeURIComponent(
          searchText
        )}&filters[1].type=200&filters[1].value=1`,
        {
          observe: 'body',
          headers: headers
        }
      )
      .pipe(
        mergeMap((response: { id: string }[]) => {
          return forkJoin(
            ...response.map((x) => {
              return this.http.get(`${this.nexales_api_url}/presentations/${x.id}/link`, {
                observe: 'body',
                headers: headers
              });
            })
          );
        }),
        tap((value) => {
          this.loader.hideSpinner();
        }),
        map((response: { id: string; name: string; link: string }[]) => {
          return {
            presentations: response.map((x) => ({
              Id: x.id,
              Description: x.name,
              Url: x.link
            }))
          };
        }),
        catchError((err) => {
          this.loader.hideSpinner();
          return observableOf(err);
        })
      );
  }
}
